import { useEffect, useRef, useState } from 'react'
import { Button, Modal, Box, IconButton } from '@mui/material'
import { useNavigate, Link } from 'react-router-dom'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import CloseIcon from '@mui/icons-material/Close'

import { Icons } from '../../components/Icons'
import '../../onBoardingV2.scss'
import imgLogo from '../../assets/icons/megaGo.svg'
import iconArrowDown from '../../assets/icons/arrowDown.svg'
import imgNext from '../../assets/icons/next.svg'

// Listado de preguntas y respuestas
const questionList = [
  {
    "title": "¿Qué incluye el plan Full de Mega GO?",
    "response": "Puedes disfrutar de todos los beneficios del Plan Básico más las Señales En Vivo de Volverías con tu ex? 2 Non-Stop, Mega Ficción, Moonbug (Kids). Capítulos de teleseries nacionales, MegaShorts, Volverías con tu ex 2, Detrás del Muro, series y programas. Además, puedes ver los capítulos 24 hrs. antes que en TV abierta."
  },
  {
    "title": "¿Cómo puedo pagar Mega GO?",
    "response": "Puedes pagar con tarjeta de crédito, débito y prepago por medio de Flow."
  },
  {
    "title": "¿Dónde está disponible Mega GO?",
    "response": <>Actualmente Mega GO sólo está disponible en Chile. Si estás fuera de Chile, únete a la membresía de Mega en <a href='https://www.youtube.com/channel/UCEpId-jtRABuZyX6D2z6FZQ/join' target='_blank' className='link' rel="noreferrer">Youtube</a></>
  },
  {
    "title": "¿Qué dispositivos son compatibles con Mega GO?",
    "response": <>Navegadores web, dispositivos móviles, tabletas, dispositivos de streaming y Smart TVs. Para ver información detallada ingresa a nuestro <a href='https://megago.cl/ayuda/article/dispositivos-compatibles-con-mega-go' target='_blank' className='link' rel="noreferrer">Centro de Ayuda.</a></>
  },
]

export default function OnboardingContainerV2(props) {
  const {
    isAuthenticated,
    isFreePlan,
    isIOS,
    isMobile,
    keycloak,
    onboardingPlans,
    geoModalType,
    handleClose,
    epgData
  } = props

  const navigate = useNavigate();
  const [annualToggle, setAnnualToggle] = useState({ full: false, sport: false })
  const plansSliderRef = useRef(null)
  const [isPlansSliderEnd, setIsPlansSliderEnd] = useState(false)

  const [previewTick, setPreviewTick] = useState(() => Date.now())

  // Los módulos de Sports solo se muestran una vez que esos planes estén activos (show_on_plans) en el backend
  const showSportsModules = [process.env.REACT_APP_MS_PLAN_SPORTS, process.env.REACT_APP_MS_PLAN_FULL_SPORTS, process.env.REACT_APP_MS_PLAN_SPORTS_ANUAL]
    .every(id => onboardingPlans.some(plan => plan.id === id))

  useEffect(() => {
    const id = setInterval(() => setPreviewTick(Date.now()), 25000)
    return () => clearInterval(id)
  }, [])

  function returnButtons() {
    if (isFreePlan) {
      return (
        <>
          <Button
            className='obHeroButton'
            variant='contained'
            endIcon={<Icons path={imgNext} />}
            onClick={() => isAuthenticated
              ? navigate('/planes')
              : window.location.replace('https://sso.mega.cl/auth/realms/megamedia/protocol/openid-connect/registrations?client_id=megago-web&response_type=code&scope=openid&email&redirect_uri=https://megago.cl/&kc_locale=cl')
            }
          >
            {isAuthenticated ? 'Selecciona un plan' : 'Crea tu cuenta'}
          </Button>
        </>
      )
    } else {
      if (isIOS) {
        return (
          <a
            href="https://apps.apple.com/cl/app/mega-go/id1571743848"
            rel="noreferrer"
          >
            <img
              alt="Descárgalo en el App Store"
              src="https://images2-mega.cdn.mdstrm.com/ott/assets-img/app-store-badge.png"
              style={{ width: "80%" }}
            />
          </a>
        )
      } else {
        return (
          <a
            href="https://play.google.com/store/apps/details?id=cl.megamedia.megago&ah=1BBIBAysiNcshGHuokWDJq1-bXk"
            rel="noreferrer"
          >
            <img
              alt="Disponible en Google Play"
              src="https://images2-mega.cdn.mdstrm.com/ott/assets-img/google-play-badge.png"
              style={{ width: "80%" }}
            />
          </a>
        );
      }
    }
  }

  const handleTogglePlan = (e, key) => {
    e.stopPropagation();
    setAnnualToggle((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Scroll del slider de planes: avanza una "pantalla" y vuelve al inicio al llegar al final
  const handleScrollPlans = () => {
    const el = plansSliderRef.current;
    if (!el) return;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    if (el.scrollLeft >= maxScrollLeft - 10) {
      el.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      el.scrollBy({ left: el.clientWidth * 0.8, behavior: 'smooth' });
    }
  };

  // Detecta si el slider de planes llegó al final para rotar la flecha del botón.
  // Solo aplica en desktop: el botón no se muestra en mobile, así que evitamos
  // engancharnos al scroll táctil sin necesidad.
  useEffect(() => {
    if (isMobile) return;
    const el = plansSliderRef.current;
    if (!el) return;
    const updatePlansSliderEnd = () => {
      const maxScrollLeft = el.scrollWidth - el.clientWidth;
      setIsPlansSliderEnd(maxScrollLeft > 0 && el.scrollLeft >= maxScrollLeft - 10);
    };
    updatePlansSliderEnd();
    el.addEventListener('scroll', updatePlansSliderEnd, { passive: true });
    window.addEventListener('resize', updatePlansSliderEnd);
    return () => {
      el.removeEventListener('scroll', updatePlansSliderEnd);
      window.removeEventListener('resize', updatePlansSliderEnd);
    };
  }, [showSportsModules, isMobile]);

  // Scroll to onboarding sections
  const scrollToSection = (id) => {
    const elemento = document.getElementById(id);
    if (elemento) {
      elemento.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Listado señales en vivo
  const PREVIEW_IMG_BASE = 'https://thumbs.cdn.mdstrm.com/thumbs/live-stream/'
  const heroPreview = `${PREVIEW_IMG_BASE}60ca5d9a4721a43eebc87865/preview.webp`
  const previewLivesList = [
    { title: 'Volverías con tu ex? 2 Non Stop', url: '/player/live/68e692eef637aae33297ef71', preview: `${PREVIEW_IMG_BASE}68e690793fb225ed5e11aad7/preview.webp` },
    { title: 'Mega 2', url: '/player/live/6526fa28ab1d478d750dee24', preview: `${PREVIEW_IMG_BASE}6526f7860f75fc601338bfcb/preview.webp` },
    { title: 'Meganoticias Ahora', url: '/player/live/60ae965b11ce5700075ed01d', preview: `${PREVIEW_IMG_BASE}60ca63f2d983c04051f22bbc/preview.webp` },
    { title: 'Mega Ficción', url: '/player/live/69ce70e376704f7ab2af6ba8', preview: `${PREVIEW_IMG_BASE}6244d3b8a654d0083811e68e/preview.webp` },
    { title: 'MegaTiempo', url: '/player/live/6685cb41804ee20012821a7a', preview: `${PREVIEW_IMG_BASE}6672fe49970da27e63321f1f/preview.webp` },
  ]

  // Listado recomendados
  const SHOW_IMG_BASE = 'https://megago.cdn.mdstrm.com/ott/api/v2/screen/images/'
  const previewShowsList = [
    { title: 'Prohibida Obsesión', url: '/serie/6a4d2773d60c944c7dda7a73', preview: `${SHOW_IMG_BASE}6acce34830f23e12efe6d2c8` },
    { title: 'Volverías con tu ex? 2', url: '/serie/6a078cc9713419388b725e17', preview: `${SHOW_IMG_BASE}6a078d8e43c908240723feda` },
    { title: 'La Roja', url: '/serie/6a8f67bdc881c2663919af11', preview: `${SHOW_IMG_BASE}6ac5d6cb3568f039ac60bb0d` },
    { title: 'La Baronesa', url: '/serie/6a5fe9ce172fee4a5771fe0c', preview: `${SHOW_IMG_BASE}6a835ad7b0a40262bed224ff` },
    { title: 'Reunión de Superados', url: '/serie/68961fcb6074c3252be661d7', preview: `${SHOW_IMG_BASE}69a584bb9aa2184df54c90c5` },
    { title: 'Libérame', url: '/serie/6ab69ad6e2fe50b44d36a642', preview: `${SHOW_IMG_BASE}6acc4a709034c1e0329af891` },
    { title: 'Detrás del Muro', url: '/serie/69a990a5a7305d513ba624f6', preview: `${SHOW_IMG_BASE}69a9915bfb02c569d12653b8` },
  ]

  // Epg funciones
  const currentMegaProgram = epgData?.programas?.['dia_' + epgData?.diaActual]?.[epgData?.posicion] || null;
  // Formatea "08:00:00" -> "08:00"
  const formatHora = (hora) => (hora ? hora.slice(0, 5) : hora);

  // Modal de geobloqueo según región (MGO-E150-H1).
  // 'latam' = Latinoamérica + España; 'world' = resto del mundo. Chile no muestra modal.
  const GEO_IMG_BASE = 'https://megago.cdn.mdstrm.com/ott/api/v3/screen/images/'
  const geoModalImages = {
    latam: [
      { alt: 'Reunión de Superados', src: `${GEO_IMG_BASE}68af7726a083b8115e30b7f4` },
      { alt: 'La Baronesa', src: `${GEO_IMG_BASE}6a5fec9ac19c6169ee16d0ce` },
      { alt: 'Jardín de Olivia', src: `${GEO_IMG_BASE}68f67a836f3358dfb76083f2` },
      { alt: 'Pituca sin Lucas', src: `${GEO_IMG_BASE}6a5fe400df8b266eb8617709` },
    ],
    world: [
      { alt: 'Volverías con tu ex? 2', src: `${GEO_IMG_BASE}6a078d8e43c908240723feda` },
      { alt: 'Reunión de Superados', src: `${GEO_IMG_BASE}68af7726a083b8115e30b7f4` },
      { alt: 'La Baronesa', src: `${GEO_IMG_BASE}6a5fec9ac19c6169ee16d0ce` },
      { alt: 'Jardín de Olivia', src: `${GEO_IMG_BASE}68f67a836f3358dfb76083f2` },
    ],
  }
  const currentGeoImages = geoModalImages[geoModalType] || geoModalImages.world

  return (
    <div className='obLivesContainer'>
      {/* Nav */}
      <Icons path={imgLogo} className='navLogo showOnMobile' />
      <div className='obNav'>
        <Icons path={imgLogo} className='navLogo hideOnMobile' />
        <nav>
          <span onClick={() => scrollToSection('secEnVivo')}>En vivo</span>
          <span onClick={() => scrollToSection('secAtributos')}>Atributos</span>
          <span onClick={() => scrollToSection('secRecomendados')}>Recomendados</span>
          <span onClick={() => scrollToSection('secPlanes')}>Planes</span>
        </nav>
        <Button
          className=''
          variant='contained hideOnMobile'
          onClick={() =>
            isAuthenticated
              ? navigate('/cuenta')
              : keycloak.login()
          }
        >
          {isAuthenticated ? 'Mi cuenta' : 'Iniciar sesión'}
        </Button>
      </div>

      {/* Mega en vivo */}
      <section className='rowOb mainWidth'>
        <div className='heroCols'>
          <div className='heroLeft'>
            <header>
              {showSportsModules ? (
                <>
                  <h2>Nuevo Plan Sports.</h2>
                  <span>La Roja se ve en 4K HDR en Mega GO.</span>
                  <p>Partidos en alta definición, transmisiones alternativas y eventos deportivos de primer nivel.</p>
                </>
              ) : (
                <>
                  <h2>Mega en vivo.</h2>
                  <span>Donde quieras.</span>
                  <p>Disfruta de los mejores programas, teleseries y eventos cuando y donde quieras.</p>
                </>
              )}

              {isMobile ?
                returnButtons()
                :
                <>
                  {/* <Button
                    className="obHeroButton"
                    variant="contained"
                    onClick={() => scrollToSection('secPlanes')}
                  >
                    Conocer más
                  </Button> */}
                  <Button
                    className="obHeroButton"
                    variant="contained"
                    onClick={() =>
                      window.location =
                      "https://sso.mega.cl/auth/realms/megamedia/protocol/openid-connect/registrations?client_id=megago-web&response_type=code&scope=openid&email&redirect_uri=https://megago.cl/&kc_locale=cl"
                    }
                  >
                    Crea tu cuenta
                  </Button>
                  <p style={{ display: "none" }}>Con tu correo o cuenta de Gmail, Facebook o Apple.</p>
                </>
              }
              {isMobile &&
                <>
                  <span className='difLine'>o</span>
                  <Button
                    className='obHeroButton'
                    variant='outlined'
                    onClick={() => isMobile
                      ? isAuthenticated
                        ? navigate('/cuenta')
                        : keycloak.login()
                      : navigate('/directing')
                    }
                  >
                    {isMobile && isAuthenticated ? 'Ingresar a mi cuenta' : 'Iniciar sesión'}
                  </Button>
                </>
              }
            </header>
          </div>
          <div className='heroRight'>
            <div className='heroMedia'>
              <span className='liveTag'>Vivo</span>
              <Link to="/player/live/608848fb45a01919d1a3352e">
                <div className='borderReflex'>
                  <figure className='ratioImgBox skeletonBg'>
                    <img src={`${heroPreview}?_=${previewTick}`} alt='Mega' />
                  </figure>
                </div>
              </Link>
              <img src={`${heroPreview}?_=${previewTick}`} alt='Mega' className='mediaReflex' />
            </div>
            {currentMegaProgram && (
              <p><b>Ahora en Mega: </b>{currentMegaProgram.nombre} | {formatHora(currentMegaProgram.programacion?.inicio)} a {formatHora(currentMegaProgram.programacion?.fin)} hrs.</p>
            )}
          </div>
        </div>
      </section>

      {/* Tus señales en vivo */}
      <section className='rowOb mainWidth' id='secEnVivo'>
        <header className='rowL'>
          <h2>Tus señales en vivo</h2>
        </header>
        <div className='scrollOnMobile'>
          <ul className='grid grid-5-cols liveShowsList'>
            {previewLivesList.map((item, i) => (
              <li key={`${item.title}-${i}`}>
                <Link to={item.url}>
                  <div className='borderReflex'>
                    <span className='liveTag'>Vivo</span>
                    <figure className="ratioImgBox skeletonBg">
                      <img src={`${item.preview}?_=${previewTick}`} alt={item.title} />
                    </figure>
                  </div>
                </Link>
                <p>{item.title}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Crea tu cuenta y disfruta */}
      <section className='rowOb mainWidth' id='secAtributos'>
        <header className='rowL'>
          <h2>Crea tu cuenta y disfruta</h2>
        </header>
        <ul className='grid grid-3-cols verticalOnMobile atributesList'>
          <li>
            <div className='boxGradient borderReflex displayIcon displayText'>
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/icon-tv.png' alt='Icono televisor' />
              <div>
                <h3>Cuando y donde quieras</h3>
                <p>Activa tu Smart TV o dispositivo favorito y disfruta de Mega GO.</p>
              </div>
            </div>
          </li>
          <li>
            <div className='boxGradient borderReflex displayIcon displayText'>
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/icon-calendar.png' alt='Icono calendario' />
              <div>
                <h3>¡Preestrenos 24 horas antes que en TV abierta!</h3>
                <p>En producciones originales, excepto primer y último capítulo.</p>
              </div>
            </div>
          </li>
          <li>
            <div className='boxGradient borderReflex displayIcon displayText'>
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/icon-events.png' alt='Icono eventos' />
              <div>
                <h3>Eventos y programas</h3>
                <p>Fútbol, Hípica y Motor, además de eventos exclusivos.</p>
              </div>
            </div>
          </li>
        </ul>
      </section>

      {/* Nuestra recomendación */}
      <section className='rowOb mainWidth' id='secRecomendados'>
        <header className='rowL'>
          <h2>Nuestra recomendación</h2>
        </header>
        <div className='scrollOnMobile'>
          <ul className='grid grid-7-cols'>
            {previewShowsList.map((item, i) => (
              <li key={`${item.title}-${i}`}>
                <div className="articleListItem">
                  <Link to={item.url}>
                    <article className="articleItemBox withContextSerie borderReflex">
                      <figure className="ratioImgBox ratioPortrait">
                        <img src={item.preview} alt={item.title} />
                      </figure>
                    </article>
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Todo Mega */}
      <section className='rowOb mainWidth'>
        <div className='boxGradient borderReflex displayText bigBanner verticalOnMobile'>
          <div>
            <h3>Empieza gratis, es rápido y fácil</h3>
            <p>Crea tu cuenta en 1 minuto, cancela cuando quieras.</p>
            <div className='osList'>
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/badge-android.png' alt='Disponible en Google Play' />
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/badge-apple.png' alt='Disponible en App Store' />
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/badge-lg.png' alt='Disponible en televisores LG' />
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/badge-samsung.png' alt='Disponible en televisores Samsung' />
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/badge-androidtv.png' alt='Disponible en televisores con sistema Android TV' />
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/badge-roku.png' alt='Disponible en Roku' />
              <img src='https://images2-mega.cdn.mdstrm.com/ott/assets-img/badge-hisense.png' alt='Disponible en Hisense' />
            </div>
          </div>
          <div>
            <Button
              className='obHeroButton'
              variant='contained'
              onClick={() =>
                isAuthenticated
                  ? navigate('/cuenta')
                  : window.location.replace('https://sso.mega.cl/auth/realms/megamedia/protocol/openid-connect/registrations?client_id=megago-web&response_type=code&scope=openid&email&redirect_uri=https://megago.cl/&kc_locale=cl')
              }
            >
              {isAuthenticated ? 'Mi cuenta' : 'Crea tu cuenta'}
            </Button>
            {!isAuthenticated &&
              <p>¿Ya tienes cuenta?
                <span
                  onClick={() => keycloak.login()}
                >
                  <b> Inicia sesión</b>
                </span>
              </p>
            }
          </div>
        </div>
      </section>

      {/* Planes */}
      <section className='rowS mainWidth' id='secPlanes'>
        <header className='rowL'>
          <h2>Planes</h2>
        </header>
        <div className='obPlansSlider'>
          <ul className='grid grid-5-cols plansSlider' ref={plansSliderRef}>
            <li>
              <div className='boxGradient borderReflex displayIcon displayText' onClick={() => navigate('/planes')}>
                <article>
                  <header className='headerPrice'>
                    <h3>Básico</h3>
                    <div>Gratis</div>
                  </header>
                  <p><b>Señales en vivo básicas</b><br />Mega, Mega2, Meganoticias, Megatiempo y Teletrak.</p>
                  <p><b>Radios en vivo</b><br />Carolina TV, Infinita, Romántica y FM Tiempo.</p>
                  <p><b>Contenido</b><br />Selección de Cultura y Actualidad.</p>
                </article>
              </div>
            </li>
            {showSportsModules &&
              <li>
                <div className='boxGradient borderReflex displayIcon displayText borderLiquid borderLiquid-2 withBtns' onClick={() => navigate('/planes')}>
                  <article>
                    <header className='headerPrice'>
                      <h3>Sports</h3>
                      <div className='priceToggle'>
                        <button
                          className={!annualToggle.sport ? 'active' : ''}
                          onClick={(e) => handleTogglePlan(e, 'sport')}
                        >Mensual</button>
                        <button
                          className={annualToggle.sport ? 'active' : ''}
                          onClick={(e) => handleTogglePlan(e, 'sport')}
                        >Anual</button>
                      </div>
                      <div>{annualToggle.sport ?
                        `$${onboardingPlans.find(plan => plan.id === process.env.REACT_APP_MS_PLAN_SPORTS_ANUAL)?.amount.toLocaleString('de') || '--'} el año`
                        :
                        `$${onboardingPlans.find(plan => plan.id === process.env.REACT_APP_MS_PLAN_SPORTS)?.amount.toLocaleString('de') || '--'} al mes`
                      }
                      </div>
                    </header>
                    {annualToggle.sport && <p className='priceProm'>Cómpralo en 12 cuotas de $2.990 sin interés</p>}
                    <div className='rowXl'>
                      <p><b>Incluye todo lo del Plan Básico.</b></p>
                      <p>Disfruta todos los partidos de La Roja rumbo al Mundial 2030 y sigue a las selecciones juveniles en sus encuentros amistosos y oficiales.</p>
                      <p>Vive los duelos en 4K HDR, con transmisiones alternativas y acceso a otros eventos deportivos de primer nivel.</p>
                      <p className='highlighted'>Prefiere el Plan Full Sports por $6.490 al mes.</p>
                    </div>
                  </article>
                </div>
              </li>
            }
            <li>
              <div className='boxGradient borderReflex displayIcon displayText' onClick={() => navigate('/planes')}>
                <article>
                  <header className='headerPrice'>
                    <h3>Light</h3>
                    <div>
                      ${onboardingPlans.find(plan => plan.id === process.env.REACT_APP_MS_PLAN_LIGHT)?.amount.toLocaleString('de') || '--'} al mes
                    </div>
                  </header>
                  <p><b>Incluye todo lo del Plan Básico.</b></p>
                  <p><b>Más canales en vivo</b><br />Mega Ficción, Volverías con tu ex? 2 Non-Stop y Moonbug (Kids).</p>
                  <p className=''><b>Catálogo On Demand</b><br />Capítulos de teleseries nacionales, MegaShorts, Volverías con tu ex 2, Detrás del Muro, series y programas.</p>
                </article>
              </div>
            </li>
            <li>
              <div className='boxGradient borderReflex displayIcon displayText borderLiquid withBtns' onClick={() => navigate('/planes')}>
                <article>
                  <header className='headerPrice'>
                    <h3>Full</h3>
                    <div className='priceToggle'>
                      <button
                        className={!annualToggle.full ? 'active' : ''}
                        onClick={(e) => handleTogglePlan(e, 'full')}
                      >Mensual</button>
                      <button
                        className={annualToggle.full ? 'active' : ''}
                        onClick={(e) => handleTogglePlan(e, 'full')}
                      >Anual</button>
                    </div>
                    <div>{annualToggle.full ?
                      `$${onboardingPlans.find(plan => plan.id === process.env.REACT_APP_MS_PLAN_FULL_ANUAL)?.amount.toLocaleString('de') || '--'} al año`
                      :
                      `$${onboardingPlans.find(plan => plan.id === process.env.REACT_APP_MS_PLAN_FULL)?.amount.toLocaleString('de') || '--'} al mes`
                    }
                    </div>
                  </header>
                  <div className='rowXl'>
                    <p><b>Incluye todo lo del Plan Light.</b></p>
                    <p><b>Contenido exclusivo</b><br />Eventos en vivo.</p>
                    <p><b>Experiencia Full</b><br />Capítulos sin publicidad para ver sin interrupciones.</p>
                    <p className='highlighted'><b>¡Antes que nadie!</b><br />Preestrenos de producciones originales 24 horas antes que en televisión abierta.</p>
                  </div>
                </article>
              </div>
            </li>
            {showSportsModules &&
              <li>
                <div className='boxGradient borderReflex displayIcon borderLiquid borderLiquid-2 displayText' onClick={() => navigate('/planes')}>
                  <article>
                    <header className='headerPrice'>
                      <h3>Full Sports</h3>
                      <div>
                        ${onboardingPlans.find(plan => plan.id === process.env.REACT_APP_MS_PLAN_FULL_SPORTS)?.amount.toLocaleString('de') || '--'} al mes
                      </div>
                    </header>
                    <p><b>Incluye todo lo del Plan Full.</b></p>
                    <p>Disfruta todos los partidos de La Roja rumbo al Mundial 2030 y sigue a las selecciones juveniles en sus encuentros amistosos y oficiales.</p>
                    <p>Vive los duelos en 4K HDR, con transmisiones alternativas y acceso a otros eventos deportivos de primer nivel.</p>
                  </article>
                </div>
              </li>
            }
          </ul>
          {!isMobile && showSportsModules &&
            <div className='obSliderNextBtn'>
              <button
                type='button'
                className={isPlansSliderEnd ? 'isEnd' : ''}
                aria-label={isPlansSliderEnd ? 'Volver al inicio de los planes' : 'Ver más planes'}
                onClick={handleScrollPlans}
              >
                <Icons path={imgNext} />
              </button>
            </div>
          }
        </div>
      </section>
      {!isAuthenticated &&
        <section className='rowOb mainWidth'>
          <div className='tableContainer tableBnr boxGradient borderReflex displayText bigBanner'>
            <p>
              <span>Si quieres contratar <b>Mega GO</b> con tu proveedor, ingresa a</span>
            </p>
            <>
              <a
                variant='outlined'
                target='_blank'
                rel="noopener noreferrer"
                href='https://www.directvgo.com/cl/home#extras'
                className='proveedores'
              >
                <img src='https://megago.cdn.mdstrm.com/ott/api/v3/screen/images/68afd30b10596b405ebbc5d2' alt='Logo DTVGO' className='dtvgo' style={{ width: 110 }} />
              </a>
              <a
                variant='outlined'
                target='_blank'
                rel="noopener noreferrer"
                href='https://www.gtd.cl/hogar/productos-hogar/television-digital/aplicaciones-gtd-tv/mega-go'
                className='proveedores'
              >
                <img src='https://megago.cdn.mdstrm.com/ott/api/v3/screen/images/68afd1d0439434f8dc0a68a5' alt='Logo GTD' className='gtd' style={{ width: 92 }} />
              </a>
              <a
                variant='outlined'
                target='_blank'
                rel="noopener noreferrer"
                href='https://www.telsur.cl/hogar/productos-hogar/television-digital/aplicaciones-gtd-tv/mega-go'
                className='proveedores'
              >
                <img src='https://megago.cdn.mdstrm.com/ott/api/v3/screen/images/68afd1f0c857822624f0107a' alt='Logo TELSUR' className='telsur' style={{ width: 115 }} />
              </a>
              <a
                variant='outlined'
                target='_blank'
                rel="noopener noreferrer"
                href='https://wom.cl/sva/megago/'
                className='proveedores'
              >
                <img src='https://megago.cdn.mdstrm.com/ott/api/v3/screen/images/68afd206800dc0868f6f61e3' alt='Logo WOM' className='wom' style={{ width: 98 }} />
              </a>
            </>
          </div>
        </section>
      }

      {/*Preguntas*/}
      <section className='rowOb mainWidth'>
        <header className='rowL'>
          <h2>¿Tienes alguna duda? Revisa aquí preguntas frecuentes.</h2>
        </header>
        <div className='obMainWidth'>
          <div className='questionList'>
            {questionList.map((question, i) => (
              <Accordion key={i + "_questions"}>
                <AccordionSummary
                  expandIcon={<Icons path={iconArrowDown} />}
                >
                  <h3>{question.title}</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p>{question.response}</p>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      </section>
      {/* Modal geoblock */}
      <Modal
        open={geoModalType !== 'none'}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="formModalContainer"
      >
        <Box className='styleBox membershipBox'>
          <IconButton
            className='IconButtonX'
            aria-label="close"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <div className=''>
            <header className='mediumHeader'>
              <img src='https://megago.cdn.mdstrm.com/ott/api/v3/screen/images/68f679051fad81fb29052193' alt='Logo Mega GO y YouTube' />
              <h3>Mega GO está disponible <br />sólo dentro de Chile</h3>
              <p>Te invitamos a unirte a la membresía de <b>Mega</b> en nuestro canal de <b>Youtube</b>, para ver en exclusiva contenidos En Vivo y On-Demand desde otros países.</p>
            </header>
            <div>
              <ul>
                {currentGeoImages.map((img, i) => (
                  <li key={`${img.alt}-${i}`}>
                    {img.src && <img src={img.src} alt={img.alt} />}
                  </li>
                ))}
              </ul>
            </div>
            <div className='centered'>
              <Button
                variant='contained'
                className='baseButton'
                href='https://www.youtube.com/channel/UCEpId-jtRABuZyX6D2z6FZQ/join'
                target='_blank'
                rel='noreferrer'
              >Únete aquí
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  )
}